export default import.meta.ROLLUP_FILE_URL_m8R6TgWxwop2r_xOIPNRtg;